export default __webpack_public_path__ + "static/media/AccountSelectorCircle.b49f16c5.svg";